import splitGroupErrors from "./splitGroupErrors";

/**
 * Return false if any group edition has a "hard" error.
 * If there are no errors or only "soft" errors, return true.
 *
 * @param edition EditionsReducerType
 *
 * @return boolean
 */
const savingAllowed = (errors: Parameters<typeof splitGroupErrors>[0]): boolean => {
  const [hardErrors] = splitGroupErrors(errors);
  return Object.keys(hardErrors).length === 0;
};

export default savingAllowed;
